module.exports = __webpack_public_path__ + "img/banner5.ea84fb26.png";